import { ReactComponent as ContactsCardSVG } from '../assets/images/contacts-card.svg';
import { ReactComponent as AutomationsCardSVG } from '../assets/images/automations-card.svg';
import { ReactComponent as FormsCardSVG } from '../assets/images/forms-card.svg';

export const datahooks = {
  crmHomeComponent: 'crm-home-component',
  homeHeader: 'crm-page-header',
  homeInboxTitle: 'home-inbox-title',
  homeInboxContent: 'home-inbox-content',
  homeInboxButton: 'home-inbox-button',
  homeInvoicesSectionTitle: 'home-invoices-section-title',
  homeInvoicesTitle: 'home-invoices-title',
  homeInvoicesContent: 'home-invoices-content',
  homeInvoicesButton: 'home-invoices-button',
  homeAllToolsSectionTitle: 'home-all-tools-section-title',
  homeAutomationsSectionTitle: 'home-automations-section-title',
  homeAutomationsSectionAction: 'home-automations-section-title',
  homeTasksSectionTitle: 'home-tasks-section-title',
  homeContactsSectionTitle: 'home-contacts-section-title',
  homeWorkflowsSectionTitle: 'home-workflows-section-title',
  homePromote: 'home-promote',
  homePromoteLink: 'home-promote-link',
  manageCardTitle: (prefix: string) => `${prefix}-manage-card-title`,
  manageCardSubtitle: (prefix: string) => `${prefix}-manage-card-subtitle`,
  manageCardButton: (prefix: string) => `${prefix}manage-card-button`,
  toolClickableWrapper: (tool: string) => `${tool}-clickable-wrapper`,
  homeCreateNewMenu: 'home-create-new-menu',
  homeCreateNewMenuButton: 'home-create-new-menu-button',
  homeCreateNewMenuItem: (item: string) => `home-create-new-menu-item-${item}`,
  integrationsTitle: 'integrations-title',
  integrationSectionTitle: (section: string) => `integration-${section}-title`,
  integrationSectionViewMore: (section: string) =>
    `integration-${section}-viewMore`,
  integrationRowTitle: (rowName: string) => `integration-row-${rowName}-title`,
  integrationRowSubtitle: (rowName: string) =>
    `integration-row-${rowName}-subtitle`,
  integrationRowConnected: (rowName: string) =>
    `integration-row-${rowName}-connected`,
  integrationRowConnectButtton: (rowName: string) =>
    `integration-row-${rowName}-connectButton`,
  crmVideoPageHeaderButton: 'crm-video-page-header-button',
  crmVideoPageHeaderButtonTooltip: 'crm-video-page-header-button-tooltip',
  demoVideoModal: "demo-video-modal"
};

export const BMComponentNames = {
  ascendBadge: 'ascend-badge-lazy-component',
  ascendUpgradeButton: 'ascend-upgrade-button-lazy-component',
  automationsDashboard: 'automations-dashboard-lazy-component',
  tasksWidget: 'tasks-web-widget',
  contactsWidget: 'contacts-widget',
  contactPicker: 'contact-picker-popover',
};

export const sketches = {
  contacts: ContactsCardSVG,
  forms: FormsCardSVG,
  createForm: FormsCardSVG,
  automations: AutomationsCardSVG,
};

export const sections = {
  inbox: 'section-inbox',
  toolCards: 'section-tool-cards',
  finance: 'section-finance',
  allTools: 'section-all-tools',
};

export const CRM_HOME_ORIGIN = 'CRM_home';
export const CRM_HOME = 'crm-home';

export const referralInfoBuilder = (sectionName: string, toolName: string) =>
  `?referralInfo=${CRM_HOME}_${sectionName}_${toolName}`;

export const experimentNames = {
  phase2newFetures: 'specs.crm.HomePhase2NewFeatures',
  crmVideo: 'specs.crm.HomeCrmVideo',
};

export const preferredRecipes = [
  'thank_you_for_contacting',
  'welcome_new_site_member',
];

export const OPPORTUNITIES_PER_ROW: number = 3;

export const WORKFLOW_TEMPLATE_IDS = {
  SCRATCH: '0d9f1eec-d36c-4d41-8816-6e7102b1adbd',
  SALES: '11111111-1111-1111-1111-111111111111',
  SITE_MEMBERS: '5760e29c-e023-44d5-8574-8de6f257565f',
  TODO: '45e90bbf-857d-47fa-9fd8-134b8ea205af',
};

export const CRM_VIDEO_URL = "https://www.youtube.com/embed/ZLZyNgH-bjk";
